import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ContentAdd from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';

import EditItemDialog from './EditItemDialog';

const styles = theme => ({
  actionBtn: {
    backgroundColor: '#448fe4',
    borderRadius: 5,
    textTransform: 'none',
  },
  actionBtnLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
  },
  actionPrePackBtn: {
    backgroundColor: '#448fe4',
    borderRadius: 5,
    marginLeft: '15px',
    textTransform: 'none',
  },
  plus: {
    color: '#FFF',
    fontSize: '18px',
    fontWeight: 600,
  },
  plusIcon: {
    display: 'inline-block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  plusWord: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'inline-block',
    },
  },
  addBtnLabel: { color: '#fff' },
  btnLabel: {
    display:'flex',
    alignItems: 'center',
    marginLeft:'10px',
    marginRight: '10px',
  }
});

class AddItemButton extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    contactId: PropTypes.number,
    formatMessage: PropTypes.func.isRequired,
    reloadStore: PropTypes.func.isRequired,
    isRetailPage: PropTypes.bool,
  };

  static defaultProps = {
    contactId: null,
    isRetailPage: false,
  };

  state = {
    open: false,
    itemType: 'pre-packed',
  };

  handleClose = () => this.setState({ open: false });

  handleOpen = itemType => this.setState({ open: true, itemType });

  render() {
    const { autoFillData, open, itemType } = this.state;
    const {
      classes,
      contactId,
      formatMessage,
      reloadStore,
      isRetailPage,
      ...props
    } = this.props;
    return (
      <div style={{display:'flex'}}>
        <Button
          className="no-line-height"
          classes={{ root: classes.addBtn, label: classes.addBtnLabel }}
          mini
          onClick={() => this.handleOpen('bulk-qty')}
          variant="fab"
          color="primary"
          {...props}
        >
          <ContentAdd />
        </Button>
        <div className={classes.btnLabel}>
          {formatMessage('Bulk Item')}
        </div>
        <Button
          className="no-line-height"
          classes={{ root: classes.addBtn, label: classes.addBtnLabel }}
          mini
          onClick={() => this.handleOpen('pre-packed')}
          variant="fab"
          color="primary"
          {...props}
        >
          <ContentAdd />
        </Button>
        <div className={classes.btnLabel}>
          {formatMessage('Packed Item')}
        </div>
        {isRetailPage && (
          <div className={classes.btnLabel} style={{ fontSize: '24px' }}>
            {formatMessage('Direct to Consumer')}
          </div>
        )}
        <EditItemDialog
          contactId={contactId}
          info={autoFillData}
          onRequestClose={this.handleClose}
          open={open}
          itemType={itemType}
          key={open}
          reloadStore={reloadStore}
          isRetailPage={isRetailPage}
        />
      </div>
    );
  }
}

export default withStyles(styles)(AddItemButton);
